import { useCallback, useContext, useRef, useState } from 'react';
import { WeekView } from '@devexpress/dx-react-scheduler-material-ui';
import { RutinSettingsContext } from '../../../../../../_Common/Components/RutinAvailabilityContext/RutinAvailabilityContext';
import { SchedulerContext } from '../../SchedulerContext';
import { nyAktivitetInitialValues } from '../Utils/NyAktivitetInitialValues';
import { AktivitetTypCellMeny } from '../../../../AktivitetTypCellMeny';
import { TSelectedDetail } from '../../../../../../../../Types/MasterDetailTypes';
import { ViewDbSettingsContext } from '../ViewDbSettingsContext';

export const WeekViewTimeTableCellComponent = (
  props: WeekView.TimeTableCellProps
) => {
  const schedulerContext = useContext(SchedulerContext);
  const rutinSettingsContext = useContext(RutinSettingsContext);
  const resourceContext = useContext(ViewDbSettingsContext);
  const [showAktivitetTypCellMeny, setShowAktivitetTypCellMeny] =
    useState(false);

  const setNyAktivitetInitialValues = useCallback(
    (
      startDate: Date | undefined,
      endDate: Date | undefined,
      groupingId: string | number | undefined
    ) => {
      schedulerContext.setNyAktivitetInitialValues(
        nyAktivitetInitialValues(
          startDate,
          endDate,
          true,
          groupingId,
          schedulerContext,
          rutinSettingsContext
        )
      );
    },
    [schedulerContext, rutinSettingsContext]
  );

  const handleDoubleClick = () => {
    if (
      resourceContext?.resources?.find(res => res.kanBoka) ||
      resourceContext.loggedInUserResource?.kanBoka
    ) {
      setShowAktivitetTypCellMeny(true);
      setNyAktivitetInitialValues(
        props.startDate,
        props.endDate,
        props.groupingInfo?.[0].id
      );
    }
  };

  const onSelectDetail = (id: TSelectedDetail) => {
    schedulerContext?.onSelectDetail?.(id) ?? '';
  };

  const ref = useRef<HTMLElement | null>(null);

  return (
    <>
      <WeekView.TimeTableCell
        {...props}
        onDoubleClick={() => {
          handleDoubleClick();
        }}
        onFocus={() => {
          schedulerContext.setNyAktivitetInitialValues(
            nyAktivitetInitialValues(
              props.startDate,
              props.endDate,
              true,
              props.groupingInfo?.[0].id,
              schedulerContext,
              rutinSettingsContext
            )
          );
        }}
        onBlur={() => {}}
      >
        <span ref={ref}>{props.children}</span>
      </WeekView.TimeTableCell>
      <AktivitetTypCellMeny
        anchorEl={ref.current}
        open={showAktivitetTypCellMeny}
        onClose={() => {
          setShowAktivitetTypCellMeny(false);
        }}
        onSelectDetail={onSelectDetail}
      />
    </>
  );
};
